module.exports = __webpack_public_path__ + "img/artillery-wagon-base-shadow-16.62c7632c.png";